import React from "react";
import DetailPengurus from "../../components/organism/DetailOverviewPengurus";
const PageDetailPengurus = () => {
  return (
    <>
      <DetailPengurus />
    </>
  );
};

export default PageDetailPengurus;
